import type { ComponentChildren } from 'preact';
import { closeModal, openModal } from '../../ui/ui-store.ts';
import { LessonEvaluationModal } from '../evaluations/EvaluationModal.tsx';
import { LessonModal } from '../lesson/LessonModal.tsx';
import { PrepWeekModal } from '../lesson/PrepWeekModal.tsx';
import { ObservationModal } from '../observations/ObservationModal.tsx';
import { QuickNoteModal } from '../observations/QuickNoteModal.tsx';
import { StudentModal } from '../students/StudentModal.tsx';
import { MeetingModal, PostitModal, TaskModal } from './SimpleModals.tsx';

/**
 * The "+ Ajouter" menu.
 *
 * The original app defined openQuick() twice (legacy/index.html:648 and :698).
 * The second definition silently won, and it had dropped the "Ajouter un
 * élève" entry — so the button existed in the code but never on screen. There
 * is one definition now, and the entry is back.
 */
const ENTRIES: readonly { label: string; hint?: string; title: string; body: () => ComponentChildren }[] = [
  {
    label: '✏️ Note rapide',
    hint: 'Prénom + observation, en une ligne',
    title: 'Note rapide',
    body: () => <QuickNoteModal />,
  },
  {
    label: '👤 Ajouter un élève',
    title: 'Ajouter un élève',
    body: () => <StudentModal studentId={null} />,
  },
  {
    label: '✨ Préparer ma semaine',
    hint: 'Placer une séance sur plusieurs jours',
    title: 'Préparer cette semaine',
    body: () => <PrepWeekModal />,
  },
  {
    label: 'Activité au semainier',
    title: 'Ajouter une activité',
    body: () => <LessonModal lessonId={null} initialDay={0} initialSlot={0} />,
  },
  { label: 'Tâche', title: 'Nouvelle tâche', body: () => <TaskModal /> },
  // Renamed from "Note rapide", which now belongs to the observation above:
  // a post-it is a reminder for the teacher, not a record about a pupil.
  { label: 'Post-it', title: 'Nouveau post-it', body: () => <PostitModal /> },
  {
    label: 'Observation / stylet',
    title: 'Nouvelle observation',
    body: () => <ObservationModal />,
  },
  {
    label: 'Évaluation classe',
    title: 'Évaluation d’une leçon',
    body: () => <LessonEvaluationModal />,
  },
  { label: 'Réunion', title: 'Nouvelle réunion', body: () => <MeetingModal /> },
];

export function QuickAdd() {
  return (
    <div class="subjectGrid" style={{ gridTemplateColumns: 'repeat(2,1fr)' }}>
      {ENTRIES.map((entry) => (
        <button
          key={entry.label}
          class="shortcut"
          onClick={() => {
            closeModal();
            openModal(entry.title, entry.body());
          }}
        >
          <b>{entry.label}</b>
          {entry.hint && <span class="small muted">{entry.hint}</span>}
        </button>
      ))}
    </div>
  );
}

export function openQuickAdd(): void {
  openModal('Ajouter rapidement', <QuickAdd />);
}
